import { mapActions, mapMutations, mapState } from 'vuex';

import { NOME_PORTAL, STATUS_IMOVEL, OPERACAO_IMOVEL, PORTAIS_COM_DESTAQUE } from "../../util/constantes.js";
import Util from "../../util/funcoes.js";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faRss } from '@fortawesome/free-solid-svg-icons';

library.add(faRss)

export default {
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      imoveisDisponiveisSelecionados: [],
      imoveisPublicadosSelecionados: [],

      imoveisAdicionados: [],
      imoveisRemovidos: [],

      currentPageImoveisPublicados: 1,
      currentPageImoveisDisponiveis: 1,

      portalSelecionado: 'CAMPAINHA',

      pesquisaImovelPublicado: {
        idNaImobiliaria: '',
      },

      pesquisaImovelDisponivel: {
        status: 'DISPONIVEL',
        idNaImobiliaria: '',
        pagina: -1,
      },

      hoverRelatorio: false,
      hoverGravar: false
    };
  },

  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter(permissao => permissao.modulo === "PORTAIS")[0];
      },
    }),
    ...mapState('portaisStore', {
      portal: state => state.portal,
      imoveisDisponiveisRecuperados: state => state.imoveisDisponiveis,
    }),
    
    nomesPortais: () => NOME_PORTAL,
    statusImoveis: () => STATUS_IMOVEL,
    operacoesImoveis: () => OPERACAO_IMOVEL,
    util: () => Util,

    isInserindo() {
      return this.portal.id === 0;
    },
    isAlterando() {
      return this.portal.id !== 0;
    },

    isVisibleImoveisPublicados() {
      return this.permissoes.visualizacao;
    },
    isVisibleBotaoGravar() {
      return this.permissoes.alteracao
    },
    isNenhumImovelDisponivelSelecionado() {
      return this.imoveisDisponiveisSelecionados.length === 0;
    },
    isNenhumImovelPublicadoSelecionado() {
      return this.imoveisPublicadosSelecionados.length === 0;
    },
    isDisabledBotaoPublicarImoveis() {
      return this.isNenhumImovelDisponivelSelecionado;
    },
    isDisabledBotaoDespublicarImoveis() {
      return this.isNenhumImovelPublicadoSelecionado;
    },
    isVisibleColunaDestaque() {
      return PORTAIS_COM_DESTAQUE.includes(this.portal.nome);
    },

    isVisibleUrlIntegracao() {
      return this.portal.urlIntegracao !== '' && this.portal.urlIntegracao !== undefined;
    },

    imoveisPublicadosRecuperados() {
      return this.portal.imoveisPublicados;
    },

    imoveisPublicados() {
      return this.imoveisPublicadosRecuperados
        .filter(this.filtrarImoveisPublicadosPorId);
    },

    qtdImoveisPublicados() {
      return this.imoveisPublicados.length;
    },

    imoveisPublicadosEmExibicao() {
      const [start, end] = this.getListRange(this.currentPageImoveisPublicados);

      return this.imoveisPublicados
        .slice(start, end);
    },

    imoveisDisponiveis() {
      const idsImoveisPublicados = this.imoveisPublicadosRecuperados
        .map(imovel => imovel.id);

      const imoveis = this.imoveisDisponiveisRecuperados
        .filter(imovel => !idsImoveisPublicados.includes(imovel.id));

      return imoveis
        .filter(this.filtrarImoveisDisponiveisPorId);
    },

    qtdImoveisDisponiveis() {
      return this.imoveisDisponiveis.length;
    },

    imoveisDisponiveisEmExibicao() {
      const [start, end] = this.getListRange(this.currentPageImoveisDisponiveis);

      return this.imoveisDisponiveis
        .slice(start, end);
    },

    legendaQtdImoveisPublicados() {
      switch(this.qtdImoveisPublicados) {
        case 0:
          return "Nenhum Imóvel publicado";
        case 1:
          return "1 Imóvel publicado";
        default:
          return `${this.qtdImoveisPublicados} Imóveis publicados`;
      }
    },

    legendaQtdImoveisDisponiveis() {
      switch(this.qtdImoveisDisponiveis) {
        case 0:
          return "Nenhum Imóvel disponível";
        case 1:
          return "1 Imóvel disponível";
        default:
          return `${this.qtdImoveisDisponiveis} Imóveis disponíveis`;
      }
    },
  },

  async created() {
    await this.restaurarPortal();
    await this.restaurarImoveisDisponiveis();
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapMutations('portaisStore', [
      'limparImoveisDisponiveis',
      'limparImoveisPublicados',
      'adicionarAosImoveisPublicados',
      'removerDosImoveisPublicados',
    ]),
    ...mapActions('portaisStore', [
      'recuperarPortal',
      'listarImoveis',
      'gravarPortal',
      'gerarRelatorioImoveisPortais',
    ]),

    filtrarImoveisPublicadosPorId(imovel) {
      const queryText = this.pesquisaImovelPublicado.idNaImobiliaria;

      return this.filtrarImovel(imovel, 'idNaImobiliaria', queryText);
    },

    filtrarImoveisDisponiveisPorId(imovel) {
      const queryText = this.pesquisaImovelDisponivel.idNaImobiliaria;

      return this.filtrarImovel(imovel, 'idNaImobiliaria', queryText);
    },

    filtrarImovel(imovel, field, queryText) {
      const isNotPesquisando = !queryText;
      if(isNotPesquisando) {
        return true;
      }

      const isSearchMatches = imovel[field].includes(queryText); 
      return isSearchMatches;
    },

    getRowKey(imovel) {
      return imovel.id;
    },

    getListRange(currentPage) {
      const MAX_ITENS_PER_PAGE = 100;

      const start = this.zeroIndex(currentPage) * MAX_ITENS_PER_PAGE;
      const end = currentPage * MAX_ITENS_PER_PAGE;

      return [start, end];
    },

    zeroIndex(n) {
      return n-1;
    },

    async selecionarPortal() {
      await this.restaurarPortal();
      await this.restaurarImoveisDisponiveis();
    },
    
    async restaurarImoveisDisponiveis() {
      this.limparPesquisaImovelDisponivel();
      this.limparImoveisDisponiveis();
      await this.pesquisarImoveisDisponiveis();
    },

    async restaurarPortal() {
      this.limparPesquisaImovelPublicado();
      this.limparImoveisPublicados();
      await this.handleRecuperarPortal();
    },

    pesquisarImoveisDisponiveis() {
      const payload = { ...this.pesquisaImovelDisponivel };
      this.showLoading();

      return this.listarImoveis(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "ERRO":
              this.$message.error("Ocorreu um erro, tente novamente");
              break;
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    async handleRecuperarPortal() {
      const payload = this.getPayloadRecuperarPortal();
      this.showLoading();

      try {
        const resultado = await this.recuperarPortal(payload);

        switch(resultado.status) {
          case 'ERRO':
            this.$message.error(resultado.mensagem);
            break;
        }
      } catch(e) {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }

      this.hideLoading();
    },

    getPayloadRecuperarPortal() {
      return {
        nome: this.portalSelecionado,
      };
    },

    selecionarImovelPublicado(imoveis) {
      this.imoveisPublicadosSelecionados = imoveis;
    },
    selecionarImovelDisponivel(imoveis) {
      this.imoveisDisponiveisSelecionados = imoveis;
    },

    loggerAdicionados(){
      this.imoveisDisponiveisSelecionados.map(item =>{this.imoveisAdicionados.push(item)})
    },

    loggerRemovidos(){
      this.imoveisPublicadosSelecionados.map(item =>{this.imoveisRemovidos.push(item)})
    },


    publicarImoveis() {
      this.adicionarAosImoveisPublicados(this.imoveisDisponiveisSelecionados);
      this.loggerAdicionados()
      this.imoveisDisponiveisSelecionados = [];
      this.$refs.tableImoveisDisponiveis.clearSelection();
    },
    despublicarImoveis() {
      this.removerDosImoveisPublicados(this.imoveisPublicadosSelecionados);
      this.loggerRemovidos()
      this.imoveisPublicadosSelecionados = [];
      this.$refs.tableImoveisPublicados.clearSelection();
    },

    handleGravar(){ 
      if(this.qtdImoveisPublicados === 0){
        this.$confirm("A lista de imóveis está vazia. Dessa forma, irá implicar em todos os anúncios relizados" +
        " anteriormente, via integração, poderão ser apagados. Deseja continuar?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning"
        }).then(() => {
         this.handleGravarPortal();
        }); 
      }else{
        this.handleGravarPortal();
      }
    },



    handleGravarPortal() {
      this.showLoading();
      const payload = this.getPayloadGravar();
      this.resetLogImoveisAlterados();
      this.gravarPortal(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'ERRO':
              this.$message.error(resultado.mensagem);
              break;
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    getPayloadGravar() {
      if(this.isInserindo) {
        return this.getPayloadInserir();
      }

      return this.getPayloadAlterar();
    },

    getPayloadInserir() {
      return {
        id: 0,
        nome: this.portalSelecionado,
        imoveisPublicados: this.portal.imoveisPublicados,
        imoveisAdicionados: this.imoveisAdicionados,
        imoveisRemovidos: this.imoveisRemovidos
      };
    },

    getPayloadAlterar() {
      return {
        id: this.portal.id,
        nome: this.portalSelecionado,
        imoveisPublicados: this.portal.imoveisPublicados,
        imoveisAdicionados: this.imoveisAdicionados,
        imoveisRemovidos: this.imoveisRemovidos
      };
    },
    
    limparPesquisaImovelDisponivel() {
      this.pesquisaImovelDisponivel.idNaImobiliaria = '';
    },
    limparPesquisaImovelPublicado() {
      this.pesquisaImovelPublicado.idNaImobiliaria = '';
    },

    handleGerarRelatorioImoveisPublicados() {
      const payload = this.getPayloadRelatorioImoveisPublicaodos();

      this.showLoading();
      this.gerarRelatorioImoveisPortais(payload).then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            window.open(resultado.mensagem, '_blank');
            break;
          case "FALHA":
            this.$message.error("Não foi possível gerar o relatório");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    resetLogImoveisAlterados(){
      this.imoveisRemovidos = [];
      this.imoveisAdicionados = [];
    },

    getPayloadRelatorioImoveisPublicaodos() {
      return {
        nome: 'IMOVEIS_PORTAIS',
        portal: {
          nome: this.portalSelecionado,
        },
      };
    },
  }
}